/**
 * WHAT THE BROWSER SAYS ABOUT ITSELF AT LOGIN (organiser, 30 Oct 2026: «модель
 * телефона… роздільну здатність… масштаб… коли пишуть що в них щось не
 * получається, то тоді можна було б хоч розуміти, як вони використовують наш
 * застосунок»). Sent beside the username and password and kept with the login
 * for «Журнал входів» — the server keeps only these keys
 * (App\Service\Audit\LoginClient).
 *
 *  - screen / viewport: CSS pixels of the screen and of the page's window;
 *  - pixelRatio: devicePixelRatio — the system's scaling times the page's zoom;
 *  - zoom: the page's own zoom, % — read as the window's outer width over its
 *    inner one, which only Chromium on a desktop keeps apart (Firefox scales
 *    both; a phone has no window); omitted elsewhere rather than guessed;
 *  - model / platformVersion: Client Hints — Chromium only; the model is what
 *    tells one Android phone from another now that its User-Agent says «K»;
 *  - touch: a touch screen — an iPad says «Macintosh» otherwise.
 *
 * Never delays a login by more than HINTS_WAIT_MS, and never fails one.
 */
const HINTS_WAIT_MS = 300;

const size = (width, height) => (width > 0 && height > 0 ? `${Math.round(width)}x${Math.round(height)}` : undefined);

/** The page's zoom in %, to the nearest 5 — or undefined where it cannot be told. */
export const pageZoom = (win, chromium, touch) => {
    if (!chromium || touch || !(win.outerWidth > 0) || !(win.innerWidth > 0)) {
        return undefined;
    }
    const zoom = Math.round((win.outerWidth / win.innerWidth) * 20) * 5;

    // A docked developer panel or a side bar narrows the page, not zooms it.
    return zoom >= 25 && zoom <= 500 ? zoom : undefined;
};

const highEntropy = win => {
    const data = win.navigator && win.navigator.userAgentData;
    if (!data || 'function' !== typeof data.getHighEntropyValues) {
        return Promise.resolve({});
    }

    return Promise.race([
        data.getHighEntropyValues(['model', 'platformVersion']).catch(() => ({})),
        new Promise(resolve => setTimeout(() => resolve({}), HINTS_WAIT_MS)),
    ]);
};

export const collectClientInfo = (win = window) => {
    try {
        const touch = (win.navigator.maxTouchPoints || 0) > 0;
        const chromium = Boolean(win.navigator.userAgentData);
        const base = {
            screen: win.screen ? size(win.screen.width, win.screen.height) : undefined,
            viewport: size(win.innerWidth, win.innerHeight),
            pixelRatio: win.devicePixelRatio || undefined,
            zoom: pageZoom(win, chromium, touch),
            touch,
        };

        return highEntropy(win)
            .then(hints => ({
                ...base,
                model: hints.model || undefined,
                platformVersion: hints.platformVersion || undefined,
            }))
            .catch(() => base);
    } catch (e) {
        return Promise.resolve({});
    }
};
